export class SubmitResult {
  constructor(
    public taxonomyValueId: string,
    public errorMessage: string) { }
}
